/*
 *
 * RestaurantDetails reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  FETCH_RESTAURANT_SUCCESS,
  SET_RESTURANT_DEAL_SUCCESS,
  SET_RESTURANT_DEAL_FORM,
} from './constants';

// const mockDealBookingResponse = {
//   "result": "We have received your request. We shall get in touch with you very soon! (Sit back until then!)",
//   "status": "1",
//   "data": {
//     "transactionid": "201807037EA198E3",
//     "bookingtime": "1 AM",
//     "bookingdate": "2018-07-18",
//     "specialrequest": "testing",
//     "numberofpeople": "2",
//     "status": "0"
//   }
// };
const initialState = fromJS({ isLoading: false, resturantData: {}, dealBookingForm: {}, dealBooking: {} });

const restaurantDetailsReducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('isLoading', payload);
    case FETCH_RESTAURANT_SUCCESS:
      return state
        .set('resturantData', fromJS(payload));
    case SET_RESTURANT_DEAL_FORM:
      return state
        .set('dealBookingForm', fromJS(payload));
    case SET_RESTURANT_DEAL_SUCCESS:
      return state
        .set('dealBooking', fromJS(payload));
    default:
      return state;
  }
};

export default restaurantDetailsReducer;



// WEBPACK FOOTER //
// client/containers/RestaurantDetails/reducer.js